import React from 'react';
import { ReactComponent as ChatbotReportsIcon } from "../../../../../assets/ChatbotReportsSvgs/ChatbotReportsIcon.svg";
import '../style.scss';
import './style.scss';

const MetricsMessageBubbleLoader: React.FC = () => (
    <div className="metrics-message-row ai-message">
        <div className="metrics-ai-avatar">
            <ChatbotReportsIcon />
        </div>
        <div className="metrics-message-bubble metrics-initiate-loading-bubble">
            <span>Analyzing your data...</span>
            <div className="metrics-typing-indicator">
                <span /><span /><span />
            </div>
        </div>
    </div>
);

export default MetricsMessageBubbleLoader;
